import { motion } from 'framer-motion';

const TrustBar = () => {
  const stats = [
    { icon: 'ri-truck-line', number: '1000', suffix: '+', label: 'Entregas Realizadas' },
    { icon: 'ri-star-smile-line', number: '99', suffix: '%', label: 'Satisfação Garantida' },
    { icon: 'ri-building-line', number: '200', suffix: '+', label: 'Empresas Atendidas' },
    { icon: 'ri-time-line', number: '15', suffix: '+', label: 'Anos de Experiência' },
  ];

  return (
    <section className="bg-white py-16">
      <div className="container mx-auto px-6 lg:px-20">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="text-center relative"
            >
              <div className="flex justify-center mb-4">
                <div className="w-16 h-16 flex items-center justify-center">
                  <i className={`${stat.icon} text-4xl text-[#1a237e]`}></i>
                </div>
              </div>
              <div className="flex items-center justify-center mb-2">
                <span className="text-4xl lg:text-5xl font-bold text-[#1a237e]">{stat.number}</span>
                <span className="text-3xl lg:text-4xl font-bold text-[#ff6f00] ml-1">{stat.suffix}</span>
              </div>
              <p className="text-sm lg:text-base font-medium text-gray-700">{stat.label}</p>
              {index < stats.length - 1 && (
                <div className="hidden lg:block absolute right-0 top-1/2 transform -translate-y-1/2 w-px h-16 bg-gray-200"></div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
